export default __webpack_public_path__ + "static/media/6.5d1835b3.jpg";